import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { EyeIcon } from "../../../assets/icons";
import { useAppContext } from "../../Context/AppContext";
import CustomTooltip from "../../CustomTooltip";
import "./RepertiInteressati.scss";

const headers = [
  { key: "codiciInventario", label: "Codici inventario", width: "40%" },
  { key: "organizzazione", label: "Organizzazione", width: "40%" },
  { key: "action", label: "", width: "10%" },
];

const getRepertoEntity = (item) => item?.reperto || item;

const formatCodiciInventario = (reperto) => {
  if (
    !Array.isArray(reperto?.codiciInventario) ||
    !reperto.codiciInventario.length
  ) {
    return "—";
  }

  return reperto.codiciInventario
    .map((item) => item.codice)
    .filter(Boolean)
    .join(", ");
};

const formatOrganizzazione = (reperto) =>
  reperto?.groups?.[0]?.organization?.name || "—";

const RepertiInteressati = ({ reperti = [] }) => {
  const navigate = useNavigate();
  const { setRepertoId } = useAppContext();

  const handleRepertoView = useCallback(
    (repertoId) => {
      if (!repertoId) return;
      setRepertoId(repertoId);
      navigate("/reperti/view");
    },
    [navigate, setRepertoId]
  );

  return (
    <div className="form-block" id="pubblicazione-reperti-interessati">
      <p className="section-title">REPERTI INTERESSATI</p>
      <div className="reperti-interessati-container">
        <div className="reperti-interessati-table-container">
          <header className="reperti-interessati-table-header">
            {headers.map((header, index) => (
              <div
                key={index}
                className="reperti-interessati-header-item"
                style={{
                  maxWidth: header.width,
                  minWidth: header.width,
                }}
              >
                <div className="reperti-interessati-header-item-text">
                  {header.label}
                </div>
              </div>
            ))}
          </header>
          {reperti.length > 0 ? (
            reperti.map((item, index) => {
              const reperto = getRepertoEntity(item);
              const row = {
                id: reperto?.id,
                codiciInventario: formatCodiciInventario(reperto),
                organizzazione: formatOrganizzazione(reperto),
              };

              return (
                <div
                  className="reperti-interessati-row reperti-interessati-row--clickable"
                  key={reperto?.id || index}
                  onClick={() => handleRepertoView(reperto?.id)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      handleRepertoView(reperto?.id);
                    }
                  }}
                  role="button"
                  tabIndex={0}
                >
                  {headers.map((header, headerIndex) => (
                    <div
                      key={`${reperto?.id}-${headerIndex}`}
                      className="reperti-interessati-row-item"
                      style={{ width: header.width }}
                    >
                      {header.key === "action" ? (
                        <CustomTooltip text="Visualizza reperto">
                          <button
                            type="button"
                            className="reperti-interessati-icons"
                            onClick={(event) => {
                              event.stopPropagation();
                              handleRepertoView(reperto?.id);
                            }}
                          >
                            <EyeIcon fillColor="var(--archeo-color)" />
                          </button>
                        </CustomTooltip>
                      ) : (
                        row[header.key]
                      )}
                    </div>
                  ))}
                </div>
              );
            })
          ) : (
            <div className="reperti-interessati-row">
              <div
                className="reperti-interessati-row-item"
                style={{ width: "100%" }}
              >
                Nessun dato presente
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RepertiInteressati;
